import { AidaService, LlmArtifactService } from '@adaptiva/ai/common';
import { UiService } from '@adaptiva/core/ui';
import { AlertComponentModule } from '@adaptiva/widgets/alert';
import { NgComponentOutlet } from '@angular/common';
import { Component, inject } from '@angular/core';
import { LlmArtifactRendererTypePipe } from './pipes';

@Component({
	selector: '[ada-llm-artifact-renderer]',
	templateUrl: './artifact-renderer.component.html',
	imports: [
		AlertComponentModule,
		LlmArtifactRendererTypePipe,
		NgComponentOutlet
	],
})
export class LlmArtifactRendererComponent {

	protected readonly aida: AidaService = inject(AidaService);

	protected readonly artifacts: LlmArtifactService = inject(LlmArtifactService);

	protected readonly ui: UiService = inject(UiService);

	protected onRendererClosed(): void {
		this.artifacts.isOpen.set(false);
	}

}
